import $ from 'jquery'

$('.tooltip-trigger').on('click', function (e) {
  e.stopPropagation()
  $(this).parent().toggleClass('tooltip--active')
})

$('html, body').on('click', function () {
  $('.tooltip').removeClass('tooltip--active')
})
